import Axios from 'axios';

export default {
  actions: {
    async getCompanies(ctx) {
      try {
        const result = await Axios.get(Axios.defaults.route + '/companies');
        if (result.data) ctx.commit('UPDATE_COMPANIES', result.data);
      } catch (e) {
        console.error("", e.message);
      }
    },
    selectCompany(ctx, id) {
      ctx.commit('UPDATE_SELECTED_COMPANY_ID', id);
    }
  },
  mutations: {
    UPDATE_COMPANIES(state, companies) {
      state.companies = companies;
    },
    UPDATE_SELECTED_COMPANY_ID(state, id) {
      state.selectedCompanyId = id;
    }
  },
  state: {
    companies: [],
    selectedCompanyId: 0
  },
  getters: {
    allCompanies(state) {
      return state.companies;
    },
    editableCompanies(state) {
      return state.companies.filter(company => company.canEdit === true);
    },
    companiesCount(state) {
      return state.companies.length;
    },
    selectedCompany(state) {
      return state.selectedCompanyId;
    }
  }
}